import React from 'react';
import { CtaButton } from './CtaButton';
import { PRICE, PRODUCT_NAME, bonuses } from '../data/offer';
export function RevelationSection() {
  const highlight = bonuses[3];
  return <section className="w-full bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="revelation-heading" data-id="element-171" data-mp="12ij10uo6zv4b">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-4 sm:gap-12 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-172" data-mp="xioais8bx7js">
        <div className="rounded-2xl border border-carbon-line bg-carbon-800 p-3" data-id="element-173" data-mp="tjfh5oh7bbor">
          <img src={highlight.image} alt="One of the pack’s PDF covers showing a runner’s stride being analyzed" className="w-full rounded-xl object-cover" loading="lazy" data-id="element-174" data-mp="oi8bbuymcmkq" />
        </div>

        <div data-id="element-175" data-mp="2dxz9xqtl7isc">
          <p className="flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.28em] text-mint sm:text-xs" data-id="element-176" data-mp="2dxpn2c3u9rqv">
            <span className="h-px w-8 bg-mint-deep/70" aria-hidden="true" data-id="element-177" data-mp="28zxs197wdpig" />
            What the top 1% do differently
          </p>
          <h2 id="revelation-heading" className="display-tight mt-5 font-display text-[28px] uppercase text-paper sm:mt-6 sm:text-[44px]" data-id="element-178" data-mp="1c5ap6qhclitu">
            The coaches charging $200+ per athlete all have{' '}
            <span className="text-mint" data-id="element-179" data-mp="17793dxsjf5eo">a proprietary drill system</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-paper-dim" data-id="element-180" data-mp="1ux3fue8y2rye">
            They don’t guess. They have a vault of movements for every specific problem. After years
            of training elite endurance athletes, we consolidated that vault into one printable PDF
            system you can open on the track.
          </p>
          <p className="mt-6 text-xl text-paper" data-id="element-181" data-mp="1q5lf9rau2tdy">
            Introducing <span className="font-semibold text-mint" data-id="element-182" data-mp="2dvxwxtvvs4hq">{PRODUCT_NAME}</span>
          </p>
          <div className="mt-9 flex" data-id="element-183" data-mp="2dtv0ar083d41">
            <CtaButton data-id="element-184" data-mp="2in7h4eynufm8">Get instant access — {PRICE}</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}